import { Button } from "@/components/ui/button";
import { FaPhoneAlt } from "react-icons/fa";

export default function CardContactSpecialist() {
  return (
    <div className="bg-white rounded-[20px] p-5">
      <div className="flex items-center gap-3 justify-start mb-3">
        <div className="bg-n-green p-2 rounded-full">
          <FaPhoneAlt className="h-4 w-4 text-n-green-action" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-n-text-green">
            Fale com um especialista
          </h3>
          <p className="text-sm text-n-text-neutral">
            Assistência personalizada sobre o seu orçamento
          </p>
        </div>
      </div>

      <Button
        variant="green"
        className="w-full h-9 bg-n-beige hover:bg-n-beige/90"
        onClick={() => window.open("tel:08008780708", "_self")}
      >
        Ligar agora
      </Button>
    </div>
  );
}
